import { createAction, props } from '@ngrx/store';
import { Supplier } from '../../pages/suppliers/supplier';
import { PremiitError } from '../../utils/premiit-error';

export const getSuppliersAction = createAction('[Suppliers] getting suppliers');

export const getSupplierSuccessAction = createAction(
  '[Suppliers] getting suppliers successfully',
  props<{ suppliers: Supplier[] }>()
);

export const getSupplierErrorAction = createAction(
  '[Suppliers] getting suppliers error',
  props<{ error: PremiitError }>()
);

export const selectSupplier = createAction(
  '[Suppliers] Select supplier',
  props<{ supplier: Supplier }>()
);

export const unSelectSupplier = createAction('[Suppliers] Unselect supplier');

export const setColor = createAction(
  '[Suppliers] set color',
  props<{ color: string }>()
);

export const createSupplierAction = createAction(
  '[Suppliers] create supplier action',
  props<{ supplier: Supplier }>()
);

export const createSupplierSuccessAction = createAction(
  '[Suppliers] create supplier successfully',
  props<{ supplier: Supplier }>()
);

export const createSupplierErrorAction = createAction(
  '[Suppliers] create supplier error',
  props<{ error: PremiitError }>()
);

export const deleteSupplierAction = createAction(
  '[Suppliers] Delete supplier',
  props<{ supplier: Supplier }>()
);

export const deleteSupplierSuccessAction = createAction(
  '[Suppliers] delete suppliers successfully',
  props<{ supplier: Supplier }>()
);

export const deleteSupplierError = createAction(
  '[Supppliers] delete suppliers error',
  props<{ error: PremiitError}>()
);

export const updateSupplierAction = createAction(
  '[Suppliers] update supplier',
  props<{ supplier: Supplier }>()
);

export const updateSupplierSuccessAction = createAction(
  '[Suppliers] update supplier successfully',
  props<{ supplier: Supplier }>()
);

export const updateSupplierErrorAction = createAction(
  '[Supplier] update supplier error',
  props<{ error: PremiitError }>()
);
